module.exports = __webpack_public_path__ + "assets/img/fr-4cc7fb22.png";